import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'lib-password-strength-checker',
  templateUrl: './password-strength-checker.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./password-strength-checker.component.css']
})
export class PasswordStrengthCheckerComponent {
  bar0: string;
  bar1: string;
  bar2: string;
  bar3: string;
  bar4: string;
  bar5: string;

  @Input() public passwordToCheck: string;

  @Output() passwordStrength = new EventEmitter<boolean>();

  private colors = ['darkred', 'red', 'orangered', 'orange', 'yellowgreen', 'green'];

  message: string;
  messageColor: string;

  checkStrength(password: string) {
    // 1
    let force = 0;

    // 2
    const repeat = /([a-zA-Z0-9])\1{2,}/g;
    const regex = /[$-/:-?{-~!"^_@`\[\]]/g;
    const lowerLetters = /[a-z]+/.test(password);
    const upperLetters = /[A-Z]+/.test(password);
    const numbers = /[0-9]+/.test(password);
    const repeatingWords = !repeat.test(password);
    const symbols = regex.test(password);
    const length = password.length >= 12;

    // 3
    const flags = [lowerLetters, upperLetters, numbers, symbols, repeatingWords, length];

    // 4
    let passedMatches = 0;
    for (const flag of flags) {
      passedMatches += flag === true ? 1 : 0;
    }

    // 7
    force = passedMatches === 1 ? 10 : force;
    force = passedMatches === 2 ? 20 : force;
    force = passedMatches === 3 ? 30 : force;
    force = passedMatches === 4 ? 40 : force;
    force = passedMatches === 5 ? 50 : force;
    force = passedMatches === 6 ? 60 : force;

    return force;
  }

  ngOnChanges(changes: { [propName: string]: SimpleChange }): void {
    const password = changes.passwordToCheck.currentValue;

    this.setBarColors(6, '#DDD');

    if (password) {
      const pwdStrength = this.checkStrength(password);
      pwdStrength === 60 ? this.passwordStrength.emit(true) : this.passwordStrength.emit(false);

      const color = this.getColor(pwdStrength);
      this.setBarColors(color.index, color.color);

      switch (pwdStrength) {
        case 10:
          this.message = 'Invalid';
          break;
        case 20:
          this.message = 'Poor';
          break;
        case 30:
          this.message = 'Needs Work';
          break;
        case 40:
          this.message = 'Ok';
          break;
        case 50:
          this.message = 'Average';
        case 60:
          this.message = 'Great';
      }
    } else {
      this.message = '';
    }
  }

  private getColor(strength: number) {
    let index = 0;

    if (strength <= 10) {
      index = 0;
    } else if (strength === 20) {
      index = 1;
    } else if (strength === 30) {
      index = 2;
    } else if (strength === 40) {
      index = 3;
    } else if (strength === 50) {
      index = 4;
    } else if (strength === 60) {
      index = 5;
    } else {
      index = 6;
    }

    this.messageColor = this.colors[index];

    return {
      index: index + 1,
      color: this.colors[index]
    };
  }

  private setBarColors(count: number, color: string) {
    for (let n = 0; n < count; n++) {
      (this as any)['bar' + n] = color;
    }
  }
}
